/* eslint-disable jira/filename-case */

import './global-react.tsx';
import './inject-why-did-you-render.tsx';
import './inject-dev-stability-render.tsx';
import './hydration-support.tsx';
